import React from 'react';
import { errorContainer, button } from './styles.module.css';

const ErrorPage = () => (
  <div className={errorContainer}>
    <a href="https://native/exit">
      <button className={button}>Back</button>
    </a>
    <h2>
      Sorry, there has been a technical error. Please try again later or contact support, if problem
      persists.
    </h2>
  </div>
);

export default ErrorPage;
